/**
  * @author Christine Movius, Ryan Gladstone
  */

function toastWrapperService($translate, ngToast, _) {
  const service = {};

  service.createToast = (content, className, dismissButton = true) => {
    ngToast.create({
      content,
      onDismiss: angular.noop,
      dismissButton,
      className
    });
  };

  service.taskUpdate = (newStatus) => {
    let toastMessage;

    if (newStatus === 3) {
      // claimed
      const acceptedOptions = [
        'TOAST_ACCEPTED_MSG1',
        'TOAST_ACCEPTED_MSG2',
        'TOAST_ACCEPTED_MSG3',
        'TOAST_ACCEPTED_MSG4',
        'TOAST_ACCEPTED_MSG5'
      ];
      toastMessage = $translate.instant(_.sample(acceptedOptions));
    } else if (newStatus === 4) {
      // rejected
      const rejectedOptions = [
        'TOAST_REJECTED_MSG1',
        'TOAST_REJECTED_MSG2',
        'TOAST_REJECTED_MSG3',
        'TOAST_REJECTED_MSG4',
        'TOAST_REJECTED_MSG5',
        'TOAST_REJECTED_MSG6',
        'TOAST_REJECTED_MSG7'
      ];
      toastMessage = $translate.instant(_.sample(rejectedOptions));
    } else if (newStatus === 5) {
      // completed
      const completedOptions = [
        'TOAST_COMPLETED_MSG1',
        'TOAST_COMPLETED_MSG2',
        'TOAST_COMPLETED_MSG3',
        'TOAST_COMPLETED_MSG4',
        'TOAST_COMPLETED_MSG5'
      ];
      toastMessage = $translate.instant(_.sample(completedOptions));
    }

    ngToast.success({
      content: toastMessage,
      onDismiss: angular.noop,
      dismissButton: true
    });
  };

  return service;
}

const serviceArray = [
  '$translate',
  'ngToast',
  '_',
  toastWrapperService
];

export default function (ngModule) {
  ngModule.service('toastWrapperService', serviceArray);
}
